import Endpoint from './endpoint'
import { API_URL } from './index'

export default class Campaigns extends Endpoint {
  async all(includeStages = false) {
    let url = new URL('/api/campaigns', API_URL)

    if (includeStages) {
      url.searchParams.set('stages', true)
    }

    return this.request(url)
  }

  async one(id) {
    let url = new URL(`/api/campaigns/${id}`, API_URL)

    return this.request(url)
  }

  async save(campaign) {
    // create or update if id exists in campaign
    let url = new URL(`/api/campaigns/${'_id' in campaign ? campaign._id : ''}`, API_URL)

    return this.request(url, {
      method: '_id' in campaign ? 'PUT' : 'POST',
      body: JSON.stringify(campaign)
    })
  }

  async delete(id) {
    let url = new URL(`/api/campaigns/${id}`, API_URL)

    return this.request(url, {
      method: 'DELETE'
    })
  }
}
